/* Venlu R19/R20 · Verhalten für Kopfzeile, Hero-Film mit Umgebungslicht, Tabs, Größen-Blatt, Sticker, Anime-Welten, Bundle-Stand, mobile Kaufleiste.
   Kein Scroll-Listener: Sichtbarkeit über IntersectionObserver, Kanji-Drift per CSS scroll-timeline.
   Medien immer stumm. Warenkorb über die vorhandene Schublade (Ereignis venlu:cart-added). */
(() => {
  'use strict';
  const d = document;
  const root = () => d.body.dataset.root || '/';
  const lang = () => (d.body.dataset.locale === 'de' || (d.documentElement.lang || '').startsWith('de')) ? 'de' : 'en';
  const t = (de, en) => lang() === 'de' ? de : en;
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = () => !!(navigator.connection && navigator.connection.saveData);
  const localize = scope => { /* Native section responses already contain translated copy. */ }; 
  const muteAll = scope => scope.querySelectorAll('video,audio').forEach(m => { m.muted = true; m.defaultMuted = true; m.volume = 0; });

  /* ---------- Kopfzeile ---------- */
  function initHeader() {
    const header = d.querySelector('[data-r19-header]');
    const sentinel = d.querySelector('[data-r19-header-sentinel]');
    if (header && sentinel && !header.dataset.r19Bound) {
      header.dataset.r19Bound = '1';
      new IntersectionObserver(([e]) => header.classList.toggle('is-compact', !e.isIntersecting)).observe(sentinel);
    }
    d.querySelectorAll('[data-r19-drop]').forEach(dr => {
      if (dr.dataset.r19Bound) return; dr.dataset.r19Bound = '1';
      dr.addEventListener('toggle', () => { if (dr.open) d.querySelectorAll('[data-r19-drop][open]').forEach(o => { if (o !== dr) o.open = false; }); });
    });
    const burger = d.querySelector('[data-r19-burger]');
    if (burger && !burger.dataset.r19Bound) {
      burger.dataset.r19Bound = '1';
      burger.addEventListener('toggle', () => {
        if (burger.open) {
          const hb = (header || burger).getBoundingClientRect().bottom;
          d.documentElement.style.setProperty('--r19-header-bottom', Math.max(0, Math.round(hb)) + 'px');
        }
        d.body.classList.toggle('r19-lock', burger.open);
      });
      burger.querySelectorAll('.r19-mnav a').forEach(a => a.addEventListener('click', () => { burger.open = false; }));
    }
  }
  d.addEventListener('click', e => {
    d.querySelectorAll('[data-r19-drop][open]').forEach(dr => { if (!dr.contains(e.target)) dr.open = false; });
  });
  d.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const open = d.querySelector('[data-r19-drop][open]') || d.querySelector('[data-r19-burger][open]');
    if (open) { open.open = false; open.querySelector('summary')?.focus(); }
  });

  /* ---------- Hero-Film ---------- */
  if (!customElements.get('r19-film')) customElements.define('r19-film', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const v = this.querySelector('video'), btn = this.querySelector('[data-r19-film-toggle]');
      if (!v || !btn) return;
      v.muted = true; v.defaultMuted = true; v.volume = 0; v.setAttribute('muted', '');
      let visible = false, userPaused = false, userStarted = false, loaded = false;
      const auto = () => !RM.matches && !saveData();
      const label = () => {
        const playing = !v.paused && !v.ended;
        btn.setAttribute('aria-pressed', String(playing));
        btn.setAttribute('aria-label', playing ? window.VenluI18n.t("r24.s_9e59ec536ec5",{},"Pause film") : window.VenluI18n.t("r24.s_3b383e35ec00",{},"Play film"));
      };
      const load = () => {
        if (loaded) return; loaded = true;
        /* R21: Auflösung nach tatsächlich nötigen Pixeln (Kartenbreite × Pixeldichte); mobil höchstens 720 px */
        const small = matchMedia('(max-width: 767px)').matches;
        const need = (this.clientWidth || 400) * (window.devicePixelRatio || 1);
        v.src = (!small && need > 780 && this.dataset.srcXl) ? this.dataset.srcXl : (need > 560 || !small ? this.dataset.srcLg : this.dataset.srcSm);
        v.load();
      };
      const sync = () => {
        const want = visible && !d.hidden && !userPaused && (auto() || userStarted);
        if (want) {
          load(); v.muted = true; v.volume = 0;
          const p = v.play(); if (p && p.catch) p.catch(() => label());
        } else if (!v.paused) v.pause();
        label();
      };
      /* R20: farbiges Umgebungslicht aus derselben Videodatei (Canvas 27×36, CSS-Weichzeichner), etwa 8 Bilder pro Sekunde,
         nur solange der Film sichtbar läuft; sonst bleibt das letzte Bild bzw. das Vorschaubild stehen. */
      const hero = this.closest('.r19-hero'); const cv = hero && hero.querySelector('[data-r19-ambient]');
      let ctx = null, raf = 0, last = 0;
      if (cv && cv.getContext) { try { ctx = cv.getContext('2d', { alpha: false }); } catch { ctx = null; } }
      const paint = src => { if (!ctx) return; try { ctx.drawImage(src, 0, 0, cv.width, cv.height); cv.classList.add('is-ready'); } catch { /* Bild noch nicht bereit */ } };
      const poster = this.querySelector('.r19-film__poster');
      if (ctx && poster) { if (poster.complete && poster.naturalWidth) paint(poster); else poster.addEventListener('load', () => paint(poster), { once: true }); }
      const loop = now => {
        raf = 0;
        if (!ctx || v.paused || v.ended || !visible || d.hidden) return;
        if (now - last > 120) { last = now; if (v.readyState >= 2) paint(v); }
        raf = requestAnimationFrame(loop);
      };
      const startLoop = () => { if (ctx && !raf && !RM.matches && !saveData()) raf = requestAnimationFrame(loop); };
      v.addEventListener('playing', () => {
        this.classList.add('is-playing'); label(); startLoop();
        if (!this.dataset.firstFrameMs) {
          const record = () => { if (!this.dataset.firstFrameMs) this.dataset.firstFrameMs = String(Math.round(performance.now())); };
          if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(record); else record();
        }
      });
      v.addEventListener('pause', label);
      v.addEventListener('volumechange', () => { if (!v.muted || v.volume > 0) { v.muted = true; v.volume = 0; } });
      btn.hidden = false;
      btn.addEventListener('click', () => { if (v.paused) { userPaused = false; userStarted = true; } else { userPaused = true; } sync(); });
      /* R21c: Kapitel-Sprung (Nutzeraktion, deshalb auch bei weniger Bewegung erlaubt) */
      this.addEventListener('r21:seek', e => {
        const to = Math.max(0, Number(e.detail && e.detail.t) || 0);
        userPaused = false; userStarted = true; load();
        const go = () => { try { v.currentTime = to; } catch (err) { /* noch nicht suchbar */ } sync(); };
        if (v.readyState >= 1) go(); else { v.addEventListener('loadedmetadata', go, { once: true }); sync(); }
      });
      d.addEventListener('visibilitychange', sync);
      d.addEventListener('venlu:languagechange', label);
      this.io = new IntersectionObserver(([e]) => { visible = e.isIntersecting && e.intersectionRatio >= 0.15; sync(); }, { threshold: [0, 0.15] });
      // Start visible hero media as soon as the deferred controller is ready.
      // Unrelated images and embeds must not gate the first frame.
      this.io.observe(this);
      const initial = this.getBoundingClientRect();
      visible = initial.height > 0 && initial.bottom > 0 && initial.top < innerHeight;
      sync();
      label();
    }
    disconnectedCallback() { this.io?.disconnect(); this.querySelector('video')?.pause(); this.ready = false; }
  });

  /* ---------- Sticker/Peek: Ersatz ohne scroll-timeline (Safari/Firefox) ---------- */
  function initStickers(scope) {
    const sdt = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
    if (sdt) return;
    const els = [...scope.querySelectorAll('[data-r19-sticker]')].filter(el => !el.dataset.r19Bound);
    if (!els.length) return;
    d.documentElement.classList.add('r19-no-sdt');
    const io = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('is-in', e.isIntersecting)), { rootMargin: '-18% 0px -18% 0px' });
    els.forEach(el => { el.dataset.r19Bound = '1'; io.observe(el); });
  }

  /* ---------- Tabs (Pill, gleitende Markierung) ---------- */
  if (!customElements.get('r19-tabs')) customElements.define('r19-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.tabs = [...this.querySelectorAll('[role=tab]')];
      this.panels = this.tabs.map(tb => d.getElementById(tb.getAttribute('aria-controls')));
      this.mark = this.querySelector('.r19-tabs__mark');
      this.tabs.forEach((tb, i) => {
        tb.addEventListener('click', () => this.select(i));
        tb.addEventListener('keydown', e => {
          const k = e.key; let n = null;
          if (k === 'ArrowRight') n = (i + 1) % this.tabs.length;
          if (k === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
          if (k === 'Home') n = 0; if (k === 'End') n = this.tabs.length - 1;
          if (n !== null) { e.preventDefault(); this.select(n, true); }
        });
      });
      this.ro = new ResizeObserver(() => { this.place(); this.edges(); }); this.ro.observe(this);
      this.place(); this.classList.add('is-ready');
      this.navBtns = [...this.querySelectorAll('[data-r19-rail-step]')];
      this.navBtns.forEach(btn => btn.addEventListener('click', () => {
        const rail = this.rail(); if (!rail) return;
        rail.scrollBy({ left: Number(btn.dataset.r19RailStep) * rail.clientWidth * 0.82, behavior: RM.matches ? 'auto' : 'smooth' });
      }));
      this.querySelectorAll('.r19-rail').forEach(r => r.addEventListener('scroll', () => this.edges(), { passive: true }));
      this.edges();
    }
    disconnectedCallback() { this.ro?.disconnect(); this.ready = false; }
    rail() { const i = this.tabs.findIndex(tb => tb.getAttribute('aria-selected') === 'true'); return this.panels[i]?.querySelector('.r19-rail'); }
    edges() {
      const r = this.rail(); if (!r || !this.navBtns) return;
      const max = r.scrollWidth - r.clientWidth - 2;
      this.navBtns.forEach(btn => { const back = btn.dataset.r19RailStep === '-1'; btn.disabled = back ? r.scrollLeft <= 2 : r.scrollLeft >= max; });
    }
    place() {
      const a = this.tabs.find(tb => tb.getAttribute('aria-selected') === 'true'); if (!a || !this.mark) return;
      this.mark.style.setProperty('--x', a.offsetLeft - 4 + 'px'); this.mark.style.setProperty('--w', a.offsetWidth + 'px');
    }
    select(i, focus) {
      this.tabs.forEach((tb, j) => { const on = i === j; tb.setAttribute('aria-selected', String(on)); tb.tabIndex = on ? 0 : -1; if (this.panels[j]) this.panels[j].hidden = !on; });
      if (focus) this.tabs[i].focus();
      this.place();
      const rail = this.panels[i]?.querySelector('.r19-rail'); if (rail) rail.scrollLeft = 0;
      this.edges();
    }
  });

  /* ---------- Stumme Kurz-Loops (Welten, Drop): nur sichtbar, nie bei weniger Bewegung oder Datensparen ---------- */
  const loopOk = () => !RM.matches && !saveData();
  const playLoop = (v, host) => {
    if (!v || !loopOk()) return;
    v.muted = true; v.defaultMuted = true; v.volume = 0; v.setAttribute('muted', '');
    if (!v.src && v.dataset.src) { v.src = v.dataset.src; }
    const on = () => host.classList.add('is-playing');
    v.addEventListener('playing', on, { once: true });
    const p = v.play(); if (p && p.catch) p.catch(() => {});
  };
  const stopLoop = (v, host) => { if (!v) return; v.pause(); host.classList.remove('is-playing'); };

  if (!customElements.get('r21-loop')) customElements.define('r21-loop', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const v = this.querySelector('video'); if (!v) return;
      this.video = v; this.visible = false;
      const eligible = () => this.isConnected && this.visible && !document.hidden && loopOk();
      this.sync = () => { if (eligible()) playLoop(v, this); else stopLoop(v, this); };
      this.playingGuard = () => { if (!eligible()) queueMicrotask(() => { if (!eligible()) stopLoop(v, this); }); };
      v.addEventListener('playing', this.playingGuard);
      document.addEventListener('visibilitychange', this.sync);
      RM.addEventListener('change', this.sync);
      this.io = new IntersectionObserver(([e]) => { this.visible = e.isIntersecting && e.intersectionRatio >= .35; this.sync(); }, { threshold: [0, .35] });
      this.io.observe(this);
    }
    disconnectedCallback() { this.io?.disconnect(); document.removeEventListener('visibilitychange', this.sync); RM.removeEventListener('change', this.sync); this.video?.removeEventListener('playing', this.playingGuard); stopLoop(this.video, this); this.visible = false; this.ready = false; }
  });

  /* ---------- Anime-Welten R21: Zeigen mit kurzer Absicht, Fokus oder Tippen öffnet; offene Welt spielt ihren Loop ---------- */
  if (!customElements.get('r19-worlds')) customElements.define('r19-worlds', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const items = [...this.querySelectorAll('.r21-w, .r19-world')];
      const desk = matchMedia('(min-width: 1024px)');
      let visible = false, timer = 0;
      const current = () => items.find(x => x.classList.contains('is-active'));
      const sync = () => items.forEach(li => {
        const on = li.classList.contains('is-active');
        li.querySelectorAll('.r21-w__shop a, .r21-w__shop button').forEach(a => { a.tabIndex = (on || !desk.matches) ? 0 : -1; });
        const v = li.querySelector('video');
        if (on && visible && desk.matches) playLoop(v, li); else stopLoop(v, li);
      });
      const sec = this.closest('section');
      const tint = li => { const c = li && li.style.getPropertyValue('--wc'); if (sec && c) sec.style.setProperty('--wc', c.trim()); };
      const activate = li => { if (!li || li.classList.contains('is-active')) return; items.forEach(x => x.classList.toggle('is-active', x === li)); tint(li); sync(); };
      items.forEach(li => {
        li.addEventListener('pointerenter', e => {
          if (e.pointerType !== 'mouse' || !desk.matches) return;
          li.classList.add('is-hover'); clearTimeout(timer); timer = setTimeout(() => activate(li), 140);
        });
        li.addEventListener('pointerleave', () => { li.classList.remove('is-hover'); clearTimeout(timer); });
        li.addEventListener('focusin', () => { if (desk.matches) activate(li); });
        const link = li.querySelector('.r21-w__link, .r19-world__link');
        link?.addEventListener('click', e => {
          if (desk.matches && !li.classList.contains('is-active')) { e.preventDefault(); activate(li); }
        });
      });
      this.io = new IntersectionObserver(([e]) => { visible = e.isIntersecting; sync(); }, { threshold: .25 });
      this.io.observe(this);
      desk.addEventListener?.('change', sync);
      RM.addEventListener?.('change', sync);
      if (!current() && items[0]) items[0].classList.add('is-active');
      tint(current());
      sync();
    }
    disconnectedCallback() { this.io?.disconnect(); this.ready = false; }
  });


  /* ---------- R22 Set-Baukasten: Anzahl und Set wählen, Preisvorteil live (Radiogruppen mit Pfeiltasten) ---------- */
  if (!customElements.get('r21-setbuilder')) customElements.define('r21-setbuilder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const q = s => this.querySelector(s);
      const ns = [...this.querySelectorAll('[data-sb-n]')], sets = [...this.querySelectorAll('[data-sb-set]')];
      const lists = [...this.querySelectorAll('[data-sb-slots]')], stages = [...this.querySelectorAll('[data-sb-stage]')];
      const st = { n: Number(this.dataset.n) || 3, set: this.dataset.set || '1' };
      const pct = n => Number(this.dataset['pct' + n]) || 0;
      const radio = (btns, isOn) => btns.forEach(b => { const on = isOn(b); b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
      const txt = (el, v) => { if (el) el.textContent = v; };
      const render = () => {
        this.dataset.n = String(st.n); this.dataset.set = st.set;
        radio(ns, b => Number(b.dataset.sbN) === st.n);
        radio(sets, b => b.dataset.sbSet === st.set);
        lists.forEach(l => { l.hidden = l.dataset.sbSlots !== st.set; });
        stages.forEach(x => x.classList.toggle('is-on', x.dataset.sbStage === st.set));
        const l = lists.find(x => !x.hidden) || {}; const ds = l.dataset || {};
        const own = st.set === '0', p = pct(st.n);
        txt(q('[data-sb-old]'), own ? '' : (ds['sum' + st.n] || ''));
        txt(q('[data-sb-new]'), own ? '' : (ds['new' + st.n] || ''));
        txt(q('[data-sb-save]'), own ? '' : (ds['save' + st.n] || ''));
        txt(q('[data-sb-pct]'), p ? '(−' + p + ' %)' : '');
        txt(q('[data-sb-pctbig]'), p ? '−' + p + '%' : '');
        this.classList.toggle('is-own', own);
        const next = st.n < 4 ? pct(st.n + 1) : 0;
        txt(q('[data-sb-next]'), own ? window.VenluI18n.t("r24.s_29d7b8a07af5",{p1:(st.n),p2:(p)},"Pick {{ p1 }} pieces: −{{ p2 }} % on the set.")
          : next ? window.VenluI18n.t("r24.s_63b14f958ee7",{p1:(next)},"1 more piece to −{{ p1 }} %") : window.VenluI18n.t("r24.s_f4e13d381bcc",{p1:(p)},"Top tier: −{{ p1 }} %"));
        this.style.setProperty('--tier', String(st.n - 2));
      };
      const bind = (btns, pick) => btns.forEach((b, i) => {
        b.addEventListener('click', () => { pick(b); render(); });
        b.addEventListener('keydown', e => {
          const k = e.key; let j = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % btns.length;
          if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + btns.length) % btns.length;
          if (k === 'Home') j = 0; if (k === 'End') j = btns.length - 1;
          if (j !== null) { e.preventDefault(); pick(btns[j]); render(); btns[j].focus(); }
        });
      });
      bind(ns, b => { st.n = Number(b.dataset.sbN) || 3; });
      bind(sets, b => { st.set = b.dataset.sbSet; });
      d.addEventListener('venlu:languagechange', render);
      render();
    }
  });

  /* ---------- Laufband ---------- */
  if (!customElements.get('r19-marquee')) customElements.define('r19-marquee', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.io = new IntersectionObserver(([e]) => this.classList.toggle('is-offscreen', !e.isIntersecting)); this.io.observe(this);
      const btn = this.querySelector('[data-r19-marquee-toggle]');
      const label = () => {
        const paused = this.hasAttribute('data-paused'); const l = lang();
        btn.setAttribute('aria-pressed', String(paused));
        btn.setAttribute('aria-label', window.VenluI18n.pair(btn.dataset[(paused ? 'labelPlay' : 'labelPause') + 'De'], btn.dataset[(paused ? 'labelPlay' : 'labelPause') + 'En']));
      };
      btn?.addEventListener('click', () => { this.toggleAttribute('data-paused'); label(); });
      if (btn) { label(); d.addEventListener('venlu:languagechange', label); }
    }
    disconnectedCallback() { this.io?.disconnect(); this.ready = false; }
  });

  /* ---------- Größen-Blatt (Schnellkauf) ---------- */
  const sheet = d.querySelector('[data-r19-sheet]');
  let sheetData = null, sel = [], trigger = null, variant = null, sheetBusy = false, sheetVersion = 0;
  let cartEditRecovery = false;
  const pendingVariants = new Set();
  const q = s => sheet.querySelector(s);
  const selectionHost = () => {
    const host = trigger?.closest('[data-r24-set-scope]')?.querySelector('r24-bundle-selection');
    return typeof host?.addPiece === 'function' ? host : null;
  };
  function varyingOptions() {
    if (!sheetData) return [];
    return sheetData.options.map((name, i) => ({ name, i, values: [...new Set(sheetData.variants.map(v => v.options[i]))] })).filter(o => o.values.length > 1 || (sheetData.colorSeedActive && /size|größe|groesse|maat|taille|talla|taglia/i.test(o.name)));
  }
  function findVariant() {
    return sheetData.variants.find(v => v.options.every((val, i) => sel[i] === undefined || sel[i] === val)) || null;
  }
  function valueAvailable(i, val) {
    if (sheetData.cartLine) return sheetData.variants.some(v => v.available && v.options[i] === val);
    return sheetData.variants.some(v => v.available && v.options[i] === val && v.options.every((x, j) => j === i || sel[j] === undefined || sel[j] === x));
  }
  function optionLabel(name) {
    const n = (name || '').toLowerCase();
    if (n === 'size' || n === 'größe') return window.VenluI18n.t("r24.s_1af851907331",{},"Size");
    if (n === 'color' || n === 'farbe') return window.VenluI18n.t("r24.s_6b73191a0a4b",{},"Color");
    return name;
  }
  function renderSheet() {
    // Read-only handoff to the shared finder: selected size is never a recommendation.
    sheet.venluFitSelection = { productURL: sheetData.url, options: [...sheetData.options], selected: [...sel] };
    /* R23: Bild folgt der gewählten Variante bzw. Farbe (Prüfer: „White“ zeigte ein schwarzes Shirt) */
    { const im = q('[data-r19-sheet-img]'); const sizeName = sheetData.cartLine ? /size|größe|groesse|maat|taille|talla|taglia/i : /size|größe/i; const pv = sheetData && sheetData.variants.filter(v => v.img).find(v => sel.every((x, i) => x === undefined || x === null || sizeName.test(sheetData.options[i] || '') || v.options[i] === x)); if (im && pv && pv.img && im.getAttribute('src') !== pv.img) { im.src = pv.img; im.hidden = false; } }
    const box = q('[data-r19-sheet-options]'); box.innerHTML = '';
    const vary = varyingOptions();
    vary.forEach(o => {
      const fs = d.createElement('fieldset');
      const lg = d.createElement('legend'); lg.textContent = optionLabel(o.name) + ' '; const cur = d.createElement('span'); cur.textContent = sel[o.i] || ''; lg.append(cur); fs.append(lg);
      const wrap = d.createElement('div'); wrap.className = 'r19-sheet__values';
      o.values.forEach(val => {
        const b = d.createElement('button'); b.type = 'button'; b.textContent = val;
        // Decorative swatches only for an explicitly named native colour axis; compound colours remain text.
        if (/^(color|colour|farbe|couleur|kleur|colore)$/i.test(String(o.name).trim())) {
          const swatch = {black:'black',schwarz:'black',noir:'black',zwart:'black',negro:'black',nero:'black',white:'white','weiß':'white',weiss:'white',blanc:'white',wit:'white',blanco:'white',bianco:'white',gray:'gray',grey:'gray',grau:'gray',gris:'gray',grijs:'gray',grigio:'gray'}[String(val).trim().toLowerCase()];
          if (swatch) { b.dataset.optionSwatch = swatch; const dot = d.createElement('span'); dot.className = 'r32-option-swatch'; dot.setAttribute('aria-hidden', 'true'); b.prepend(dot); }
        }
        const ok = valueAvailable(o.i, val);
        b.setAttribute('aria-pressed', String(sel[o.i] === val));
        if (!ok) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-label', val + ' ' + window.VenluI18n.t("r24.s_dcbe3413cdd2",{},"sold out")); }
        b.dataset.opt = String(o.i);
        b.disabled = sheetBusy;
        b.addEventListener('click', () => {
          if (!ok || sheetBusy) return; sel[o.i] = val;
          if (sheetData.cartLine && !sheetData.variants.some(v => v.available && v.options.every((x, i) => sel[i] === undefined || sel[i] === x))) {
            // A different colour may need a newly chosen size; never silently substitute one.
            sel = sel.map((x, i) => i === o.i ? x : undefined);
            sheetData.options.forEach((name, i) => { const values = [...new Set(sheetData.variants.map(v => v.options[i]))]; if (values.length === 1) sel[i] = values[0]; });
          }
          renderSheet();
          const again = [...box.querySelectorAll(`button[data-opt="${o.i}"]`)].find(x => x.textContent === val); again?.focus({ preventScroll: true });
        });
        wrap.append(b);
      });
      fs.append(wrap); box.append(fs);
    });
    const complete = vary.every(o => sel[o.i] !== undefined);
    variant = complete ? findVariant() : null;
    const add = q('[data-r19-sheet-add]'), lab = q('[data-r19-sheet-add-label]');
    const first = (sheetData.colorSeedActive && sheetData.variants.find(v => v.available && v.options.every((val, i) => sel[i] === undefined || val === sel[i]))) || sheetData.variants.find(v => v.available) || sheetData.variants[0];
    q('[data-r19-sheet-price]').textContent = (variant || first).price;
    if (!complete) { add.disabled = true; lab.textContent = vary.length && vary[0].name.toLowerCase().match(/size|größe/) ? window.VenluI18n.t("r24.s_6579e5beaf79",{},"Select a size") : window.VenluI18n.t("r24.s_a3ce509a5406",{},"Make a selection"); }
    else if (!variant || !variant.available) { add.disabled = true; lab.textContent = window.VenluI18n.t("r24.s_1a27eedbc636",{},"Sold out"); }
    else { add.disabled = false; lab.textContent = (sheetData.cartLine ? window.VenluI18n.t("r24.s_79f4c56f403c",{},"Update cart") : selectionHost() ? trigger.dataset.selectionReplace !== undefined ? window.VenluI18n.t("r24.s_22f8694da0fb",{},"Update selection") : window.VenluI18n.t("r24.s_7f9e6e964175",{},"Add to selection") : window.VenluI18n.t("r24.s_0e9408353c72",{},"Add to cart")) + ' · ' + variant.price; }
    if (sheetBusy || pendingVariants.has(variant?.id)) { add.disabled = true; lab.textContent = window.VenluI18n.t("r24.s_e1dbf0a2747f",{},"Adding …"); }
    if (sheetData.cartLine && sheetBusy) lab.textContent = window.VenluI18n.t("r24.s_ea4e7e65e867",{},"Updating …");
    if (cartEditRecovery) { add.disabled = true; lab.textContent = window.VenluI18n.t("r24.s_69179f127478",{},"Check cart first"); }
  }
  // Compact SSR transport only; restore the unchanged native QuickSheet contract before any selection logic.
  function parseQuickData(text) {
    const data = JSON.parse(text);
    if (data?.variantFormat !== 'r32-tuple1') return data;
    if (!Array.isArray(data.variants)) throw Error('Invalid variant data');
    data.variants = data.variants.map(v => {
      if (!Array.isArray(v) || v.length !== 7 || !Number.isSafeInteger(v[0]) || !Array.isArray(v[3]) || typeof v[4] !== 'boolean' || !Number.isSafeInteger(v[5])) throw Error('Invalid variant tuple');
      return { id: v[0], img: v[1], title: v[2], options: v[3], available: v[4], cents: v[5], price: v[6] };
    });
    delete data.variantFormat;
    return data;
  }
  function openSheet(btn) {
    const card = btn.closest('[data-r19-card]'); const raw = card?.querySelector('[data-r19-quick-data]');
    if (!sheet || !raw) return;
    if (btn.hasAttribute('data-cart-edit')) {
      const drawer = d.querySelector('vn-cart-drawer');
      if (typeof drawer?.replaceLine !== 'function' || drawer.locked()) return;
      const form = btn.closest('#vn-cart-form');
      if (form && [...form.querySelectorAll('input[name="updates[]"]')].some(input => input.value !== input.defaultValue)) {
        const status = d.querySelector('[data-cart-page-status]'); if (status) status.textContent = window.VenluI18n.t("r24.s_79f4c56f403c",{},"Update cart");
        form.querySelector('[name="update"]')?.focus({preventScroll:true}); return;
      }
    }
    try { sheetData = parseQuickData(raw.textContent); } catch { location.href = card.querySelector('a')?.href || root(); return; }
    trigger = btn; sel = []; sheetVersion++; sheetBusy = false; cartEditRecovery = false;
    // Optional reviewed-photo colour only. Never interpret a complete variant as a size recommendation.
    const seed = sheetData.colorSeed, colorName = /^(color|colour|farbe|couleur|kleur|colore)$/i;
    sheetData.colorSeedActive = Boolean(seed && !btn.dataset.selectionVariant && Number.isInteger(seed.index) && colorName.test((sheetData.options[seed.index] || '').trim()) && sheetData.options.filter(name => colorName.test(name.trim())).length === 1 && sheetData.variants.some(v => v.available && v.options[seed.index] === seed.value));
    sheetData.options.forEach((name, i) => { const vals = [...new Set(sheetData.variants.map(v => v.options[i]))]; if (vals.length === 1 && !(sheetData.colorSeedActive && /size|größe|groesse|maat|taille|talla|taglia/i.test(name))) sel[i] = vals[0]; });
    if (sheetData.colorSeedActive) sel[seed.index] = seed.value;
    if (btn.dataset.selectionVariant) { const previous = sheetData.variants.find(v => String(v.id) === btn.dataset.selectionVariant); if (previous) sel = [...previous.options]; }
    if (sheetData.cartLine) {
      const previous = sheetData.variants.find(v => Number(v.id) === Number(sheetData.cartLine.variantId));
      if (!previous) { location.href = sheetData.url; return; }
      sel = [...previous.options];
    }
    q('[data-r19-sheet-title]').textContent = sheetData.title;
    const seedImage = sheetData.colorSeedActive && sheetData.variants.find(v => v.options[seed.index] === seed.value && v.img)?.img;
    const img = q('[data-r19-sheet-img]'); img.loading = 'eager'; if (seedImage || sheetData.image) { img.src = seedImage || sheetData.image; img.hidden = false; } else img.hidden = true;
    const guide = q('[data-r19-sheet-guide]'); guide.href = root() + 'pages/size-guide'; guide.hidden = false;
    q('[data-r19-sheet-url]').href = sheetData.url;
    const st = q('[data-r19-sheet-status]'); st.textContent = ''; st.dataset.error = 'false';
    q('[data-r19-sheet-recovery]').hidden = true;
    q('[data-r19-sheet-add]').removeAttribute('aria-busy');
    renderSheet(); localize(sheet);
    if (!sheet.open) { sheet.showModal(); d.body.classList.add('r19-lock'); }
    (q('.r19-sheet__values button:not([aria-disabled="true"])') || q('[data-r19-sheet-close]'))?.focus({ preventScroll: true });
  }
  function closeSheet() { if (sheet?.open) sheet.close(); }
  if (sheet && !sheet.dataset.r19Bound) {
    sheet.dataset.r19Bound = '1';
    d.body.classList.add('r26-cart-edit-ready');
    sheet.addEventListener('close', () => { d.body.classList.remove('r19-lock'); if (trigger?.isConnected && !sheet.dataset.added) trigger.focus({ preventScroll: true }); delete sheet.dataset.added; });
    sheet.addEventListener('click', e => {
      if (e.target.closest('[data-r19-sheet-close]')) { closeSheet(); return; }
      if (e.target === sheet) { const r = q('.r19-sheet__panel').getBoundingClientRect(); if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) closeSheet(); }
    });
    q('[data-r19-sheet-add]').addEventListener('click', async () => {
      if (!variant || !variant.available || sheetBusy || pendingVariants.has(variant.id)) return;
      const add = q('[data-r19-sheet-add]'), st = q('[data-r19-sheet-status]');
      const chosen = variant, version = sheetVersion, addedFrom = trigger;
      if (sheetData.cartLine) {
        const drawer = d.querySelector('vn-cart-drawer');
        if (typeof drawer?.replaceLine !== 'function' || cartEditRecovery) return;
        sheetBusy = true; renderSheet(); add.setAttribute('aria-busy', 'true');
        st.dataset.error = 'false'; st.textContent = window.VenluI18n.t("r24.s_ea4e7e65e867",{},"Updating …");
        const result = await drawer.replaceLine(sheetData.cartLine, chosen, sheetData.url);
        if (version !== sheetVersion) return;
        sheetBusy = false; add.removeAttribute('aria-busy');
        if (result.ok) {
          if (sheet.open) { sheet.dataset.added = '1'; closeSheet(); }
          if (addedFrom.hasAttribute('data-cart-full-edit')) { location.reload(); return; }
          drawer.focusLine(result.key); return;
        }
        cartEditRecovery = Boolean(result.recovery); renderSheet();
        st.dataset.error = 'true'; st.textContent = result.error;
        q('[data-r19-sheet-recovery]').hidden = !result.recovery;
        return;
      }
      const selection = selectionHost();
      if (selection) {
        const selected = selection.addPiece({ id: chosen.id, title: sheetData.title, variantTitle: chosen.title, url: sheetData.url, image: q('[data-r19-sheet-img]')?.getAttribute('src') || sheetData.image, cents: chosen.cents, replaceIndex: addedFrom.dataset.selectionReplace });
        if (selected === true) { closeSheet(); if (addedFrom.dataset.selectionReplace !== undefined) selection.querySelector('[data-selection-edit="'+addedFrom.dataset.selectionReplace+'"]')?.focus({preventScroll:true}); }
        else { st.dataset.error = 'true'; st.textContent = selected; }
        return;
      }
      const request = new AbortController(), timer = setTimeout(() => request.abort(), 20000);
      pendingVariants.add(chosen.id); sheetBusy = true; renderSheet();
      add.setAttribute('aria-busy', 'true'); st.dataset.error = 'false'; st.textContent = window.VenluI18n.t("r24.s_e1dbf0a2747f",{},"Adding …");
      q('[data-r19-sheet-recovery]').hidden = true;
      try {
        const r = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: chosen.id, quantity: 1 }] }), signal: request.signal });
        const j = await r.json();
        if (!r.ok) {
          if (version === sheetVersion) { st.dataset.error = 'true'; st.textContent = typeof j.description === 'string' ? j.description : window.VenluI18n.t("r24.s_54e071ddebdc",{},"This size or quantity is unavailable. Please adjust your selection."); }
          return;
        }
        if (version === sheetVersion) {
          st.textContent = window.VenluI18n.t("r24.s_4191ff574bc4",{},"Added to your cart.");
          sheet.dataset.added = '1'; closeSheet();
          d.dispatchEvent(new CustomEvent('venlu:cart-added', { detail: { trigger: addedFrom } }));
        } else {
          // A later product sheet must not be closed by this earlier response.
          try { const r = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', signal: request.signal }); if (r.ok) { const cart = await r.json(); d.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count); } } catch { /* Confirmed add remains saved. */ }
        }
        d.dispatchEvent(new CustomEvent('venlu:cart-updated'));
      } catch {
        if (version === sheetVersion) {
          st.dataset.error = 'true'; st.textContent = window.VenluI18n.t("r24.s_f4267f9847de",{},"The connection was interrupted. Check your cart before adding again.");
          q('[data-r19-sheet-recovery]').hidden = false;
        }
      } finally {
        clearTimeout(timer); pendingVariants.delete(chosen.id);
        if (version === sheetVersion) { sheetBusy = false; add.removeAttribute('aria-busy'); renderSheet(); }
        else if (sheetData && !sheetBusy) renderSheet();
      }
    });
  }
  d.addEventListener('click', e => {
    const b = e.target.closest('[data-r19-quick]'); if (!b) return;
    e.preventDefault(); openSheet(b);
  });

  /* ---------- Bundle-Stand nach Warenkorb-Änderung neu laden ---------- */
  let bundleTimer;
  function refreshBundle() {
    const hosts = d.querySelectorAll('[data-r19-bundle-host]'); if (!hosts.length) return;
    clearTimeout(bundleTimer);
    bundleTimer = setTimeout(async () => {
      try {
        const r = await fetch(root() + '?section_id=r19-bundle-progress', { cache: 'no-store' }); if (!r.ok) return;
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const fresh = doc.querySelector('[data-r19-bundle]'); if (!fresh) return;
        hosts.forEach(h => { h.innerHTML = fresh.outerHTML; localize(h); });
      } catch { /* Anzeige bleibt beim letzten bestätigten Stand */ }
    }, 350);
  }
  d.addEventListener('venlu:cart-updated', refreshBundle);
  d.addEventListener('venlu:cart-added', refreshBundle);

  /* ---------- Produktseite: mobile Kaufleiste ---------- */
  function initBuybar() {
    const bar = d.querySelector('[data-r19-buybar]'); if (!bar || bar.dataset.r19Bound) return; bar.dataset.r19Bound = '1';
    const form = d.getElementById('vn-product-form'); const submit = form?.querySelector('.add-to-cart'); if (!form || !submit) return;
    const meta = bar.querySelector('[data-r19-buybar-meta]');
    const update = () => {
      const s = form.querySelector('select[name="id"]'); const o = s?.selectedOptions?.[0]; if (!o || !meta) return;
      const title = (o.textContent || '').trim();
      meta.textContent = (title && title !== 'Default Title' ? title + ' · ' : '') + (o.dataset.money || '');
    };
    form.addEventListener('change', () => setTimeout(update, 0));
    bar.hidden = false;
    /* Wächter-Fläche vom Seitenanfang bis unter den Kauf-Knopf: verlässt sie den Bildschirm, ist der Knopf überscrollt.
       Robust auch bei Sprüngen (Anker, Zurück-Navigation), weil die Fläche dabei immer eine Grenze kreuzt. */
    const guard = d.createElement('span');
    guard.setAttribute('aria-hidden', 'true');
    guard.style.cssText = 'position:absolute;left:0;top:0;width:1px;pointer-events:none;visibility:hidden';
    d.body.appendChild(guard);
    const size = () => { const r = submit.getBoundingClientRect(); guard.style.height = Math.max(1, Math.round(r.bottom + window.scrollY)) + 'px'; };
    size(); window.addEventListener('resize', size, { passive: true }); window.addEventListener('load', size, { once: true });
    new IntersectionObserver(([e]) => {
      const past = !e.isIntersecting;
      bar.classList.toggle('is-visible', past); d.body.classList.toggle('r19-has-buybar', past);
    }).observe(guard);
    bar.querySelector('[data-r19-buybar-add]').addEventListener('click', () => {
      if (submit.disabled) { submit.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'center' }); return; }
      update();
      if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
    });
    update();
  }

  /* Schublade: Hinweis „Damit ist der Versand kostenlos“ gilt nur für die vorgewählte Variante */
  d.addEventListener('change', e => {
    const s = e.target.closest && e.target.closest('[data-cart-upsell] select'); if (!s) return;
    const n = s.form && s.form.querySelector('.r19-upsell-note'); if (n) n.hidden = s.value !== (s.querySelector('option[selected]') || s.options[0]).value;
  });

  /* ---------- Seitenübergang R21: nur noch eine ruhige Kreuzblende per CSS (@view-transition), Kopfzeile bleibt stehen.
     Das fliegende Produktbild (R19/R20) ist entfernt: in der Aufnahme blieb zwischen alter und neuer Seite eine dunkle Lücke
     mit gedimmtem Bild. Robin: lieber dezent und ruckelfrei als spektakulär. ---------- */

  /* ---------- Drop-Landingpage: Filter nach Art ohne Neuladen ---------- */
  function initDropFilter(scope) {
    scope.querySelectorAll('[data-r21-drop]').forEach(root => {
      if (root.dataset.r21Bound) return; root.dataset.r21Bound = '1';
      const btns = [...root.querySelectorAll('.r21-dl__f')], status = root.querySelector('.r21-dl__status');
      const apply = f => {
        btns.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.f === f)));
        if (f === 'all') root.removeAttribute('data-filter'); else root.dataset.filter = f;
        const n = [...root.querySelectorAll('.r21-dl__item')].filter(li => li.offsetParent !== null).length;
        if (status) status.textContent = window.VenluI18n.t("r24.s_bf4d7aecf21d",{p1:(n)},"{{ p1 }} pieces");
      };
      btns.forEach(b => b.addEventListener('click', () => apply(b.dataset.f)));
      root.addEventListener('venlu:dropmore', () => apply(root.dataset.filter || 'all'));
      d.addEventListener('venlu:languagechange', () => apply(root.dataset.filter || 'all'));
    });
  }

  /* ---------- Hero R21c: Film-Kapitel (gerade sichtbares Shirt markiert, Antippen springt im Film dorthin) ---------- */
  function initChapters() {
    const hero = d.querySelector('.r19-hero'); if (!hero || hero.dataset.chapBound) return;
    const film = hero.querySelector('r19-film'), v = film && film.querySelector('video');
    const chaps = [...hero.querySelectorAll('.r21-chap[data-t]')]; if (!film || !v || !chaps.length) return;
    hero.dataset.chapBound = '1';
    const ts = chaps.map(li => parseFloat(li.dataset.t) || 0);
    const chip = film.querySelector('[data-r21-filmchip]');
    let cur = -1;
    const set = (i, p) => {
      if (i !== cur) {
        chaps.forEach((li, j) => {
          li.classList.toggle('is-active', j === i); li.classList.toggle('is-done', j < i);
          const b = li.querySelector('[data-r21-chap]'); if (b) { if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }
          if (j !== i) li.style.setProperty('--p', j < i ? 1 : 0);
        });
        if (chip && cur !== -1) {
          const li = chaps[i]; chip.href = li.dataset.href;
          const n = chip.querySelector('.r21-filmchip__n'), pr = chip.querySelector('.r21-filmchip__p'), im = chip.querySelector('img');
          if (n) n.textContent = li.dataset.name; if (pr) pr.textContent = li.dataset.price; if (im && li.dataset.img) im.src = li.dataset.img;
          chip.classList.remove('is-swap'); void chip.offsetWidth; chip.classList.add('is-swap');
        }
        cur = i;
        if (chaps[i].dataset.color) hero.style.setProperty('--film', chaps[i].dataset.color);
      }
      chaps[i].style.setProperty('--p', p.toFixed(3));
    };
    const at = () => {
      const now = v.currentTime, dur = v.duration || 0; let i = 0;
      for (let j = 0; j < ts.length; j++) if (now >= ts[j] - 0.03) i = j;
      const end = i + 1 < ts.length ? ts[i + 1] : dur;
      set(i, end > ts[i] ? Math.min(1, Math.max(0, (now - ts[i]) / (end - ts[i]))) : 0);
    };
    v.addEventListener('timeupdate', at); v.addEventListener('seeked', at);
    chaps.forEach((li, i) => li.querySelector('[data-r21-chap]')?.addEventListener('click', () => {
      set(i, 0);
      film.dispatchEvent(new CustomEvent('r21:seek', { detail: { t: ts[i] + 0.04 } }));
      const r = film.getBoundingClientRect();
      if (r.bottom < 120 || r.top > innerHeight - 160) film.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'center' });
    }));
    set(0, 0);
  }

  /* ---------- R21c: Rückenprint-Bilder nur auf Zeige-Geräten vorladen (nach dem Laden, im Leerlauf) ---------- */
  function initPrintHover() {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches || saveData()) return;
    const warm = () => d.documentElement.classList.add('r21-warm');
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
  }

  /* ---------- R21c: Bildflug Karte -> Produktseite (Shopify Horizon: Name erst beim Klick, etwa 250 ms, nur ohne „weniger Bewegung“).
     Seitenübergreifende View Transition: Die angeklickte Karte gibt ihrem Bild kurz den Namen r21-prod, die Produktseite trägt ihn
     am Hauptbild (CSS). Beim Verlassen der Produktseite zu einer anderen Seite fliegt nichts zurück. ---------- */
  let vtImg = null, vtAt = 0;
  d.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[href*="/products/"]'); if (!a) return;
    const card = a.closest('[data-r19-card], .r21-w__pick, .r21-sb__slot, .r21-chap');
    const img = card && (card.querySelector('.r19-card__media > img') || card.querySelector('img'));
    vtImg = img || null; vtAt = performance.now();
  }, true);
  window.addEventListener('pageswap', e => {
    if (!e.viewTransition) return;
    const main = d.querySelector('.vn-purchase #vn-main-image'); if (main) main.style.viewTransitionName = 'none';
    let to = ''; try { to = new URL(e.activation && e.activation.entry ? e.activation.entry.url : '', location.href).pathname; } catch (err) { to = ''; }
    if (!/\/products\//.test(to) || RM.matches || !vtImg || !vtImg.isConnected || performance.now() - vtAt > 4000) return;
    const r = vtImg.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight || r.width < 24) return;
    vtImg.style.viewTransitionName = 'r21-prod';
  });
  window.addEventListener('pageshow', () => {
    d.querySelectorAll('[style*="view-transition-name"]').forEach(el => { el.style.viewTransitionName = ''; });
    vtImg = null;
  });
  /* R21h: runde Köpfe im Anime-Menü vorladen, bevor das Menü aufgeht (sonst leere Kreise beim ersten Öffnen) */
  function warmHeads() {
    const go = () => d.querySelectorAll('.r21-head img[loading="lazy"], .r22-wlogo img[loading="lazy"], .r22-mega__colimg img[loading="lazy"]').forEach(i => { i.loading = 'eager'; });
    d.querySelectorAll('.r19-nav, .r19-burger').forEach(el => { if (el.dataset.r21Warm) return; el.dataset.r21Warm = '1'; ['pointerenter', 'focusin', 'touchstart'].forEach(ev => el.addEventListener(ev, go, { once: true, passive: true })); });
  }
  /* R22: Drop-Seite, das feste Bild links zeigt die Figur, deren Zeile gerade im Blick ist */
  function initDropStage(scope) {
    scope.querySelectorAll('.r22-dl').forEach(root => {
      if (root.dataset.r22Bound) return; root.dataset.r22Bound = '1';
      const pics = [...root.querySelectorAll('.r22-dl__pic')]; if (!pics.length) return;
      const show = f => pics.forEach(p => p.classList.toggle('is-on', p.dataset.fig === f));
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) show(e.target.dataset.fig); }), { rootMargin: '-45% 0px -50% 0px' });
      root.querySelectorAll('.r22-dl__row').forEach(r => io.observe(r));
    });
  }
  function init() { warmHeads(); initHeader(); initBuybar(); initStickers(d); initDropFilter(d); initDropStage(d); initChapters(); initPrintHover(); muteAll(d); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', e => { initHeader(); initStickers(e.target); initDropFilter(e.target); muteAll(e.target); localize(e.target); });
})();
